import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const MessageApiUtils = {
  // fetch up to 30 conversations. Add load more in the future
  fetch(conversation_id) {
    return xhr(ApiConstants.fetchMessages + conversation_id + '/messages');
  },

  markRead(conversation_id, message_id) {
    const split_id = message_id.split('/');
    const message_uuid = split_id[split_id.length - 1];
    return xhr(
      ApiConstants.fetchMessages +
        conversation_id +
        '/messages/' +
        message_uuid,
      {
        method: 'put',
      },
    );
  },

  loadMore(conversationId, lastMessageId, lastMessageSentAt) {
    var query = '';
    let lid = lastMessageId ? lastMessageId : '';
    let lSentAt = lastMessageSentAt ? parseInt(lastMessageSentAt) : '';
    if (lid !== '' && lSentAt !== '') {
      query = `?sent=${lSentAt}&lid=${lid}`;
    }
    return xhr(
      ApiConstants.fetchMessages +
        conversationId.toString() +
        '/messages' +
        query,
    );
  },

  sendMessage(messageObj) {
    let a = messageObj.conversation_id.split('/');
    const cid = a[a.length - 1];
    return xhr(ApiConstants.sendMessage + cid + '/messages', {
      method: 'post',
      body: JSON.stringify({ message_obj: messageObj }),
    });
  },
};

export default MessageApiUtils;
